"use client"

import Image from "next/image"
import { useState } from "react"
import { cn } from "@/lib/utils"

const screens = [
  { id: "signin", label: "Sign In", image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame%2023-CJXMd7dqNcvdozeqFl6JMU2LWMKWQm.png" },
  { id: "flowers", label: "Flowers & Fillers", image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame%2024-MPZukg8SdQDtZFXm0XX4q6LRlOeI92.png" },
  { id: "customization", label: "Customization", image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame%2025-fvtlfK2YSh7Mj2fHDidLIy4l1ZNQcD.png" },
  { id: "foliage", label: "Foliage & Leaves", image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame%2026-Y8leUJJxzlucFK1ECpCLzPil6BThwF.png" },
]

export function AppPreviewSection() {
  const [activeScreen, setActiveScreen] = useState(screens[0].id)

  return (
    <section id="app-preview" className="py-20 lg:py-32 overflow-hidden" style={{ backgroundColor: '#387F43' }}>
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-secondary font-semibold text-sm uppercase tracking-wider">
            App Preview
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6 text-balance">
            Experience Harvest Flow
          </h2>
          <p className="text-lg text-white/70 leading-relaxed">
            Explore the intuitive mobile app for managing flower procurement, sales dashboards, farm inventory, and invoicing all in one platform.
          </p>
        </div>

        {/* Screen Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {screens.map((screen) => (
            <button
              key={screen.id}
              onClick={() => setActiveScreen(screen.id)}
              className={cn(
                "px-6 py-3 rounded-full font-medium transition-all",
                activeScreen === screen.id
                  ? "text-white hover:opacity-90"
                  : "bg-white/10 text-white/70 hover:bg-white/20 hover:text-white"
              )}
              style={activeScreen === screen.id ? { backgroundColor: '#5BA865' } : {}}
            >
              {screen.label}
            </button>
          ))}
        </div>

        {/* Phone Mockups */}
        <div className="relative flex justify-center items-center">
          {/* Main Phone */}
          <div className="relative w-72 md:w-80 lg:w-96 aspect-[9/19] rounded-[3rem] bg-foreground p-2 shadow-2xl z-20">
            <div className="w-full h-full rounded-[2.5rem] overflow-hidden bg-card relative">
              {screens.map((screen) => (
                <Image
                  key={screen.id}
                  src={screen.image}
                  alt={screen.label}
                  fill
                  className={cn(
                    "object-cover transition-opacity duration-500",
                    activeScreen === screen.id ? "opacity-100" : "opacity-0"
                  )}
                />
              ))}
            </div>
            {/* Notch */}
            <div className="absolute top-4 left-1/2 -translate-x-1/2 w-28 h-7 bg-foreground rounded-full" />
          </div>

          {/* Left Phone (smaller, faded) */}
          <div className="absolute left-4 md:left-12 lg:left-32 w-48 md:w-56 lg:w-64 aspect-[9/19] rounded-[2rem] bg-foreground/80 p-1.5 shadow-xl z-10 opacity-50 transform -rotate-6 scale-90">
            <div className="w-full h-full rounded-[1.5rem] overflow-hidden bg-card relative">
              <Image
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame%2025-fvtlfK2YSh7Mj2fHDidLIy4l1ZNQcD.png"
                alt="Customization Screen"
                fill
                className="object-cover"
              />
            </div>
          </div>

          {/* Right Phone (smaller, faded) */}
          <div className="absolute right-4 md:right-12 lg:right-32 w-48 md:w-56 lg:w-64 aspect-[9/19] rounded-[2rem] bg-foreground/80 p-1.5 shadow-xl z-10 opacity-50 transform rotate-6 scale-90">
            <div className="w-full h-full rounded-[1.5rem] overflow-hidden bg-card relative">
              <Image
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame%2026-Y8leUJJxzlucFK1ECpCLzPil6BThwF.png"
                alt="Foliage & Leaves Screen"
                fill
                className="object-cover"
              />
            </div>
          </div>

          {/* Decorative Circles */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full blur-3xl" style={{ backgroundColor: 'rgba(91, 168, 101, 0.2)' }} />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full blur-2xl" style={{ backgroundColor: 'rgba(91, 168, 101, 0.3)' }} />
        </div>
      </div>
    </section>
  )
}
